// This file is auto-generated by `php artisan stimulus:install`
// Run that command whenever you add a new controller or create them with
// `php artisan stimulus:make controllerName`

import {application} from '../libs/stimulus'


import FlashController from './flash_controller'
import PlacesAutocomplete from './../libs/PlacesAutocomplete'
import {Confetti} from "./../libs/myConfetti"

application.register('flash', FlashController)

// import HelloController from './hello_controller'
// application.register('hello', HelloController)

application.register('places', PlacesAutocomplete)

application.register('confetti', Confetti)
